<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Activate the account') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active">{{ $t('Activate the account') }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- log in section start -->
        <section class="log-in-section otp-section section-b-space">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                        <div class="image-contain">
                            <img src="/theme/assets/images/inner-page/otp.png" class="img-fluid" alt="">
                        </div>
                    </div>

                    <div class="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                        <div class="d-flex align-items-center justify-content-center h-100">
                            <form class="log-in-box" @submit.prevent="activation()">
                                <div class="log-in-title">
                                    <h3 class="text-title">{{ $t('Enter the verification code') }}</h3>
                                    <h5 class="text-content">
                                        <!-- عرض الرسالة بناءً على طريقة الإرسال -->
                                        <span v-if="auth.user('email')">
                                            {{ $t('A code has been sent to your email') }}: <span style="direction: ltr">{{ auth.user('email') }}</span>
                                        </span>
                                        <span v-else>
                                            {{ $t('A code has been sent to your mobile') }}: <span style="direction: ltr">{{ auth.user('mobile') }}</span>
                                        </span>
                                    </h5>
                                </div>

                                <!-- عرض الخطأ إذا وجد -->
                                <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" :class="{ 'show' : error !== null }" role="alert">
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                    <strong>{{error}}</strong>
                                </div>

                                <!-- حقول إدخال الكود -->
                                <div id="otp" class="inputs d-flex flex-row justify-content-center" style="direction: ltr">
                                    <input v-model="otpValues[0]" class="text-center form-control rounded" type="text" maxlength="1" placeholder="">
                                    <input v-model="otpValues[1]" class="text-center form-control rounded" type="text" maxlength="1" placeholder="">
                                    <input v-model="otpValues[2]" class="text-center form-control rounded" type="text" maxlength="1" placeholder="">
                                    <input v-model="otpValues[3]" class="text-center form-control rounded" type="text" maxlength="1" placeholder="">
                                </div>

                                <!-- العد التنازلي لإعادة الإرسال -->
                                <div class="send-box pt-4">
                                    <h5>
                                        <countdown></countdown>
                                    </h5>
                                </div>

                                <!-- زر التفعيل -->
                                <button class="btn btn-animation w-100 mt-3" type="submit">{{ $t('Validate') }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- log in section end -->
    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import Countdown from "./countdown.vue";

export default {
    inject: ['auth'],
    components: {
        Countdown
    },
    data() {
        return {
            otpValues: ['', '', '', ''],
            item: {
                code: null,
            },
            error: null,
        }
    },
    created() {
        // إذا لم يكن المستخدم مسجل الدخول، يتم توجيهه إلى الصفحة الرئيسية
        // if(this.auth.isLoggedIn() === false){
        //     this.$router.push({name: 'home'});
        // }
    },
    watch: {
        '$user.value': function (user) {
            if(user?.data?.verified === true){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
        '$userLoggedIn.value': function (newVal) {
            if(newVal === false){
                this.$router.push({name: 'home', params: { lang : this.$i18n.locale }});
            }
        },
    },
    methods: {
        activation() {
            const that = this;

            const id = toast.info(this.$t('Membership is in progress...'), { icon: 'fa-solid fa-cloud-arrow-up' });

            this.item.code = this.otpValues.join('');

            this.auth.activation({
                'data': this.item,
                'on_success': function (response) {
                    toast.dismiss(id);
                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, { icon: 'fa-solid fa-circle-check' });

                    that.item = {};
                    that.error = null;
                    that.$router.push({name: 'home', params: { lang : that.$i18n.locale }});
                },
                'on_fail': function (message) {
                    that.error = message;
                },
                'on_completed': function () {
                    toast.dismiss(id);
                }
            });
        }
    },
}
</script>
